// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { USER_ACCESS_URL } from '../user-access.constants';
import { PAYMENT_METHOD_URL } from './payment-method.constants';
import { API_COMMON_BASE_URL } from '../../utils/api.constants';
import { PaymentMethodDetails } from './payment-method.interfaces';
import { AxiosHookResponse, useAxiosPostRequest } from '../../utils/axios-request.hooks';
import { CreateOrderParam, OrderDetailsWithPaymentIntentInfo } from '../../order-processing/order';

export const deletePaymentMethod = (shopId: number, id: string): Promise<AxiosResponse<PaymentMethodDetails>> => {
  const url = `${API_COMMON_BASE_URL}/${USER_ACCESS_URL}/shops/${shopId}/${PAYMENT_METHOD_URL}/${id}`;

  return axios.delete(url);
};

export const useCreatePaymentMethod = (
  shopId: number
): AxiosHookResponse<CreateOrderParam, OrderDetailsWithPaymentIntentInfo> => {
  const url = `${API_COMMON_BASE_URL}/${USER_ACCESS_URL}/shops/${shopId}/${PAYMENT_METHOD_URL}`;

  return useAxiosPostRequest(url);
};
